import { OnInit, Component } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { GlobalComponent } from '../environments/global';

@Component({
    selector: 'app-home',
    templateUrl: 'track.component.html',
    styleUrls: ['track.component.scss']
})

export class TrackComponent implements OnInit {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public g: GlobalComponent,
    ) { }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.router.navigateByUrl('/track/(trackContent:utente)');
        
        
        // #################################################################################################### DEBUG
        // this.g.userData.ordini = JSON.parse(localStorage.getItem('webcheck'));
        // this.router.navigateByUrl('/track/(trackContent:insert)');
    }
}
